// Impultienda checkout funnel "Mate Collection" (store argentine-mate-experience).
export const CHECKOUT_URL = "https://argentine-mate-experience.impultienda.ar/o/mate-collection";
// Fill in when the product's Meta pixel is chosen.
export const META_PIXEL_ID = "";
